module.exports = __webpack_public_path__ + "static/media/hot_zmhs.a65459c2.png";